<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
    <b-card>
          <div slot="header">
            <strong>P2P Custom Sync</strong>
           <div class="card-header-actions" >                
             
            </div>
          </div>
            <b-row class="mb-1">          

            <!--     <b-col md="6" class="my-1">
                    <b-col sm="12" >
                   <b-form-group label="Delivery Agent"  label-size="sm"
                      :label-cols="3" >                   
                      <v-select id="mySelect" v-model="selectedagent" :options="this.data1" @input="getp2pcustomcount" placeholder="Search" name="selectedagent" v-validate="'required'" :class="{ danger: errors.has('selectedagent') }">
                      </v-select>
                      
                    </b-form-group> 
                    </b-col>   
                </b-col>  -->

                  <b-col sm="6" class="my-1">
                     <b-col sm="12" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              </b-col>
                <!-- <b-col md="6" class="my-1">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="pendingreport"> Search</b-button>
                 &nbsp;&nbsp;&nbsp;
                  
               </b-form-group>
             </b-col> -->
                 
              
              </b-row>
       <!--        <b-row >
             <b-col sm="4" class="my-1">
              <b-col sm="12" >
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              </b-col>
            </b-row> -->
            
           
              <!--  <div id="overlay" >
             <div class="loader"></div>
           </div> -->

 
             <b-row>
              <b-col sm="12" class="text-right">
                <!-- <b-button v-if="this.total_row_product >0"  @click="downloadCSV" variant="primary" size="md" >Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
              </b-col> 
          </b-row>

        <b-col sm="12" >
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
            <template slot="agentname" slot-scope="row">
              {{row.item.agent_name}} -- {{row.item.deliveryagentmasterid}}
            </template>
             <template slot="action" slot-scope="row">
              <div>
           <!--   <router-link
        to="/riderwise_productdetails"
      >    --> 
              <b-button v-b-tooltip.hover title="Product Details" size="sm" @click="riderwiseproductdetails(row.item)" style="background: #b0c4de !important;color: #000 !important;" class="mr-1">
                    View
                  </b-button>
                  <b-button v-b-tooltip.hover title=" Click to get GatePass via Email" @click="getcsvFile(row.item)"  size="sm"  style="background: #b0c4de !important;color: #000 !important;" class="mr-1">Generate GatePass
                    <!-- <i class="fa fa-envelope-o" aria-hidden="true" ></i> -->
                  </b-button>
                  <div id="overlay" >
             <div class="loader"></div>
           </div>
          <!-- </router-link> -->
              </div>
              
             </template>
          </b-table>
        </b-col>
          <b-col md="12" class="my-1 " >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>   

           <b-modal size="xl" title="Custom Gate Pass Product Details" v-model="riderwisedetails">
          <!-- <template slot="modal-header" slot-scope="{ close }">
          <h5>Shipment Listing</h5>
          </template> -->
            <div id="overlay" >
             <div class="loader"></div>
           </div>

          <!-- v-if="this.totalRows >0"  -->
          <b-row >
             <b-col sm="6" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="productfilter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!productfilter" @click="productfilter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="text-right">
                <b-button v-if="this.total_row_product >0"  @click="downloadCSV" variant="primary" size="md" >Download </b-button> 
               <p > <b>Total Records :<span style="color:red;">{{total_row_product}}</span></b> </p>
              </b-col> 
          </b-row>
          <b-table show-empty stacked="md"  :items="meproductlisting" :busy="isBusyproduct"  :fields="productfields"  :current-page="currentPageproduct"   :per-page="perPageproduct"  :filter="productfilter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
           <!--  {{row.item.user_type == 0 ? 'Normal ' : row.item.user_type == 1 ? 'Privilage':'Warehouse'}} -->
             

       
          </b-table>

      <b-col md="12" class="my-1 " v-if="this.total_row_product > 10">
            <b-pagination
                v-model="currentPageproduct"
                :total-rows="total_row_product"
                :per-page="perPageproduct"
                class="my-0"
              ></b-pagination>
          </b-col>    


    
        
      </b-modal> 

         

        
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'riderwiseofd', 
  data: function() {
    return {
        name: 'riderwiseofd',
        isBusy: false,           
        items:[],
        grandtotal:0,
        data1:[],
        fields: [
            // { key: 'deliveryagentmasterid', label: 'ID' },
            { key: 'agentname', label: 'Agent Name'},
             { key: 'deliveryagentmobilenumber', label: 'Agent Mobile No'},
            { key: 'vehicleno', label: 'Vehicle  Number'},
             { key: 'p2p_ofd_count', label: 'P2P OFD Count'},
              { key: 'custom_ofd_push_count', label: 'Custom Sync Count'},
            { key: 'action', label: 'Action'},
       
                                         
         ], 
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        currenthubidselct:'',
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        selectedagent:'',
        // productfilter:null,
        total_row_product:0,
        currentPageproduct:1,
     perPageproduct:20,
        meproductlisting:[],
         productfields: [
         { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productid', label: 'Product ID', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'taxpaid', label: 'TaxPaid', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'invoicenumber', label: 'Invoice Number', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productname', label: 'Product Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'hsncode', label: 'HSN Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productquantity', label: 'Product Quantity', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productvalue', label: 'Product Value', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'basecost', label: 'Base Cost', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'countrycode', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'countryoforigin', label: 'Country Of Origin', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'modetransport', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
              
                                         
         ], 
         isBusyproduct:false,
        melisting:[],
        sortDesc: false,
        allowCustomValue : true,
        sortDirection: 'desc',
        filter: null,
        productfilter:null,
        riderwisedetails:false,
        selecteddeliveryagentid:null,
        // showValues:false
    }
  },
  created: function() {  
    this.displaydata();
    this.getp2pcustomcount();
    
  },
 
  methods: {
    getp2pcustomcount:function(){
  //           var userdata = localStorage.getItem('userData')
  //       var userInfo = JSON.parse(userdata)
  //       const deliveryagentobj = {}
  // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getp2pcustom_synccount`, deliveryagentobj)
  // .then(result => {
  //          console.log("jjjjjjjj",result);
  //    if(result.body.returnmsg === "Successful"){
  //               // this.ofd = result.body.returnvalue;
  //                 this.items  = result.body.returnvalue;
  //                 console.log("iiiiiiii",this.items);
  //               this.totalRows = result.body.returnvalue.length
  //             }
  //         else {
  //             this.items  = [];
  //               this.totalRows = 0
  //          //alert('Records Not available');
  //         }
             

  //       }).catch(ex => {
  //           console.log('error-----', ex)
  //       });

         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       // this.showValues=true;
      this.isBusy = true;
       // var deliveryagentid=(this.selectedagent!=null)? this.selectedagent:"";


       // if(this.selectedagent!='' &&  this.selectedagent!=null){

       const synccount = {
        
      }
      // console.log("ifObj",pendingObj);
  
    

      // const reportObj={},
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getp2pcustom_synccount`, synccount)
        .then((result) => {
          // this.agentmaster = result.body;
          // console.log("result",result);
           if (result.body.returnmsg === 'Successful') {
             // this.currentPage=1;
             this.items  = result.body.returnvalue;
             // this.grandtotal= result.body.returnvalue[0].grandtotal;

             // console.log("tthis.grandtotal ",this.grandtotal );
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
             // this.grandtotal=0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      // }
     //  else{


     //    const synccount = {}
     //  // console.log("ifObj",pendingObj);
  
    

     //  // const reportObj={},
     // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getp2pcustom_synccount`, synccount)
     //    .then((result) => {
     //      // this.agentmaster = result.body;
     //      // console.log("result",result);
     //       if (result.body.returnmsg === 'Successful') {
     //         // this.currentPage=1;
     //         this.items  = result.body.returnvalue;
     //          // this.grandtotal= result.body.returnvalue[0].grandtotal;
     //         // console.log("this.items ",this.grandtotal );
     //         this.totalRows = result.body.returnvalue.length;
     //         this.isBusy = !this.isBusy;
     //      } else {
     //        this.items=[];
     //        this.totalRows =0;
     //          // this.grandtotal=0;
     //        this.isBusy = !this.isBusy;
     //      }
     //    })
     //    .catch((ex) => {
     //      console.log('error', ex)
     //    })
     //  }
    },
    getcsvFile:function(value){
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        this.selecteddeliveryagentid=value.deliveryagentmasterid;
        const deliveryagentobj = {
          deliveryagentmasterid:value.deliveryagentmasterid,
          sysusermasterid:userInfo.sysusermasterid,
        }
        console.log("Obje",deliveryagentobj);
        // return false;
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getCustomGatePassDataCsvNew`, deliveryagentobj)
  .then(result => {
    document.getElementById("overlay").style.display = "none";
           // console.log("jjjjjjjj",result);
     // if(result.body.returnmsg === "Successful"){
          alert("Please Check Your Mail For Downlod Link")
                
              // }
          // else {
          //    document.getElementById("overlay").style.display = "none";
          //    alert(result.body.returnvalue);
          // }
             

        }).catch(ex => {
            console.log('error-----', ex)
        });

    },
    
   riderwiseproductdetails:function(value){
        // alert(value.deliveryagentmasterid)
      // this.riderwisedetails =! this.riderwisedetails;
      this.isBusyproduct=true;
                var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.selecteddeliveryagentid=value.deliveryagentmasterid;
        const deliveryagentobj = {
          deliveryagentmasterid:value.deliveryagentmasterid,
        }
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/get_customgatepassdata`, deliveryagentobj)
  .then(result => {
           // console.log("jjjjjjjj",result);
     if(result.body.returnmsg === "Successful"){
      // alert("innn");
                // this.ofd = result.body.returnvalue;
                  this.meproductlisting  = result.body.returnval;
                  // console.log("iiiiiiii",this.items);
                this.total_row_product = result.body.returnval.length;
                this.riderwisedetails =! this.riderwisedetails;
                this.isBusyproduct =! this.isBusyproduct;
              }
          else {
              this.meproductlisting  = [];
                this.total_row_product = 0;
                this.isBusyproduct =! this.isBusyproduct;
                  this.riderwisedetails=false;
           //alert('Records Not available');
          }
             

        }).catch(ex => {
            console.log('error-----', ex)
        });
   },
   downloadCSV: function() {
       document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
          var csvObj = {
             deliveryagentmasterid:this.selecteddeliveryagentid,
            sysusermasterid:`${userInfo.sysusermasterid}`,
          };
          // console.log("csvObj",csvObj);
          // return false;

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcustomgatepassdatacsv`,csvObj)
        .then(result => {
         // console.log(result.url);
            document.getElementById("overlay").style.display = "none";
         if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Ur Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       });  
       }
       else
       {
        alert("Can not Download");
        // this.$fire({
        //           text:"Can not Download",
        //           type: "error",
        //           timer: 30000
        //         });  
       }
        //window.location.href =result.url;
        });

        
    },
    

    displaydata: function () {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        const deliveryagentobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
           hub_id:`${userInfo.pickuplocationmasterid}`,
        }
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagentobj)
  .then(result => {
            this.data1 = result.body;          
            var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentfirstname+ '  '+srData.deliveryagentlastname+ ' - '+srData.deliveryagentmasterid
                });
              });
              this.data1 = data;
              this.data1.unshift({"label": "All", "key": 0});

        }).catch(ex => {
            console.log('error-----', ex)
        });
    }
    
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+' : '+ " " + strTime;
      }
    }
  }
 
};
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

   #mySelect  {
   width: 230px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
